import {Quote} from '../domain/types';
import {error} from '../utils/log';
import TradingBlockRemote from './TradingBlockRemote';

export default {
    loadBySymbolList: (symbols)=> {
        return new Promise((resolve, reject) => {
            if (process.env.VUE_APP_SFT_ACCESS) {
                ForeCore.PredictionHelper.GetSymbolQuotes(symbols, (response) => {
                    resolve(JSON.parse(response.json).value.Quotes);
                }, reject);
            } else {
                const xhr = ($.ajax)({
                    type: 'POST',
                    cashe: false,
                    headers: {
                        'X-AjaxPro-Method': 'GetSymbolQuotes',

                    },
                    url: 'http://stockforecast.velvetech.com/ajaxpro/ForeCore.PredictionHelper,ForeCore.ashx',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    crossDomain: true,
                    data: '{\"symbols\": ' + JSON.stringify(symbols) + '}',
                    success: (response,
                              textStatus, jqXHR) => {
                        if (!response.value || response.value.ErrorCode > 0) {
                            return reject();
                        }
                        return resolve(response.value.Quotes);
                    },
                    error: (data, textStatus, jqXHR) => {
                        error.log(textStatus, JSON.stringify(jqXHR));
                        return reject();
                    },
                });

                return xhr;
            }
        });
    },

    loadFromTradingBlock: (id, symbols)=> {
        return new Promise((resolve, reject) => {
            const xhr = new TradingBlockRemote({
                onComplete: (res) => {
                    resolve(res);
                    },
                onFailure: (err) => {
                    reject(err);
                },
            }).GetQuotes(id, symbols);
        });
    }
}
